import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";

import { Link } from "react-router-dom";
import { onMessage } from "firebase/messaging";
import { messaging } from "src/firebase/firebase";
import { useSnackbar } from "src/context/SnackbarContext";
import { readDarkModeSetting } from "src/data/person/darkModeFunctions";

const FirebaseNotification = () => {
  const { openSnackbar } = useSnackbar();
  onMessage(messaging, (payload) => {
    openSnackbar({
      message: "zxcvbnm " + payload.data.title + "\n" + payload.data.body,
      severity: payload.data.type || "info",
    });
    toast(
      <Display
        title={payload.data.title}
        body={payload.data.keikkaString + "\n" + payload.data.body}
        keikkaId={payload.data.keikkaId}
      />,
      {
        type: payload.data.type || "info",
        theme: readDarkModeSetting() ? "dark" : "light",
      }
    );
  });

  function Display(props) {
    const title = props.title;
    const body = props.body;
    const keikkaId = props.keikkaId;

    const styles = {
      body: { whiteSpace: "pre-line" }, // This is to preserve line breaks in the toast message
    };
    const link = keikkaId > 0 ? "/tilaus/" + keikkaId : "/";

    return (
      <Link to={link}>
        <Typography variant="h6">{title}</Typography>
        <Typography variant="body" style={styles.body}>
          {body}
        </Typography>
      </Link>
    );
  }
  Display.propTypes = {
    title: PropTypes.string,
    body: PropTypes.string,
    keikkaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  };

  return <ToastContainer />;
};

FirebaseNotification.propTypes = {
  title: PropTypes.string,
  body: PropTypes.string,
};

export default FirebaseNotification;
